export const quoteDetailsRowRenderClasses = {
  cardContainer: 'flex! flex-wrap! justify-end',
  cardHeaderRight: 'flex flex-wrap justify-end items-center divide-x-2 gap-2',
  viewTerminalInfoLink:
    'font-medium! pl-2! text-[#026EA1]! text-sm! underline!',
  costDetailsLink: 'font-medium! pl-2! text-[#026EA1]! text-sm!',
  costDetailsInfoIcon: 'mr-1!',
  marginText: 'pl-2! text-sm!',
  marginTextContainer: 'font-medium!',
  StatusTextContainer: 'font-medium! flex gap-1 items-center',
  carrierLogo: 'max-h-[120px]! max-w-[150px]! object-fill!',
  labelText: 'text-xs! text-[#00000099]!',
  infoText: 'text-base! text-wrap! wrap-break-word! ',
  infoTextBold: 'text-base! font-medium! text-wrap! wrap-break-word! ',
  amountHeading: 'text-xl! w-full! font-medium! text-center!',
  carrierAmountText: 'text-[#06910B]! text-base! text-center!',
  amountDetailsContainer: 'flex divide-x-2 justify-center w-full gap-3',
  liabilityText: 'flex! gap-2! ',
  statusBtn:
    'w-[91px] h-7! flex justify-center items-center text-[#FFFFFF] rounded text-xs',
  logoBox: '!flex justify-center! flex-col!',
  indentedLabel: 'ml-5!',
  tightSpacing: 'mt-[-2px]! mb-[-2px]!',
  boldText: 'font-bold!',
  container: 'w-full! !flex h-full',
  popoverContainer: 'mb-2!',
  popoverButton: '!flex items-center! text-[#307eac]! p-0!',
  fullHeightColumn: '!flex flex-col! justify-between! h-full!',
  terminalPopoverRoot: 'flex justify-center items-center',
  carrierNoteLabel: 'text-xs! font-bold! text-[#1B4960]! shrink-0! mr-2!',
  carrierNoteText:
    'text-xs! font-normal! text-[#00000099]! text-wrap! wrap-break-word!',
};
export const savedLTLQuotesActionsClasses = {
  buttonBgColor: 'bg-[#248670]!',
  orderBtn: 'bg-[#1B4960]!',
  moreVertiIcon: 'cursor-pointer',
};
